<template>
     <div class="yzPhone-page_header">
            <div class="yzPhone-page_title">
                <p class="title">找回登录密码</p>
                <p class="tips">为了保障您的账号安全，请先进行安全验证</p>
            </div>
            <div class="yzPhone-page_steps">
                <el-steps :active="active" simple process-status="finish" finish-status="success">
                    <el-step title="填写账号" icon="el-icon-edit"></el-step>
                    <el-step title="验证手机号"  icon="el-icon-mobile-phone"></el-step>
                    <el-step title="设置新密码"  icon="el-icon-setting"></el-step>
                    <el-step title="完成"  icon="el-icon-success"></el-step>
                </el-steps>
            </div>

        </div>
</template>

<script>
export default {
    name: 'forgetPwdTitle',
    props: ['active'],
    data(){
        return{

        }
    },
}
</script>
<style scoped>
.yzPhone-page_title{
    text-align: center;
    width: 782px;
    margin: 0 auto;
    margin-top: 70px;
}
.yzPhone-page_title .title{
    font-size: 24px;
    font-weight: 600;
    color: #383838;
    margin-bottom: 5px;
}
.yzPhone-page_title .tips{
    font-size: 14px;
    color: #999999;
    padding-bottom: 50px;
}
.yzPhone-page_steps{
    width: 782px;
    margin: 0 auto;
}
@media (max-width: 767px) {
  /deep/ .el-steps--simple{
    padding:10px 4%
  }
  .yzPhone-page_title{
      width: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      margin: 0 auto;
      & .title{
        font-size:1rem;
      }
      & .tips{
        font-size:0.8rem;
      }
  }
  .yzPhone-page_steps{
   width: 96%;
  }
  .yzPhone-page_header{
    width: 100%;
  }
  /deep/ .el-step__head{
    position: relative;
  }

  /deep/ .el-step__title{
    font-size: 0.7rem !important;
  }
  /deep/ .el-step.is-simple:not(:last-of-type) .el-step__title{
    max-width: 100%;
  }
  /deep/ .el-step.is-simple .el-step__arrow::before{
    width: 0;
    height: 0;
    display:'none'
  }
  /deep/ .el-step.is-simple .el-step__arrow::after{
    width: 0;
    height: 0;
    display:'none'
  }

}
@media (min-width: 768px) and (max-width: 1024px) {
  .yzPhone-page_title{
    width: 100%;
  }
  .yzPhone-page_header{
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/public/forgetPwdTitle.vue